/* eslint-disable max-len */
import React from 'react';

const LayoutSlidesIcon = props => (
  <svg width={50} height={50} viewBox="0 0 50 50" {...props}>
    <path
      fill="currentColor"
      d="M3 2h5a1 1 0 0 1 1 1v44a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1zm0 1v44h5V3H3zm9-1h26a1 1 0 0 1 1 1v44a1 1 0 0 1-1 1H12a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1zm0 1v44h26V3H12zm30-1h5a1 1 0 0 1 1 1v44a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1zm0 1v44h5V3h-5z"
    />
  </svg>
);

export default LayoutSlidesIcon;
